module.exports = __webpack_public_path__ + "img/exam_1.99654c1b.png";